import * as React from "react";

function SvgTasks({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M16.5 12.25a5.25 5.25 0 01.216 10.496l-.216.004-.216-.004A5.251 5.251 0 0116.5 12.25zm-3.328-10c.663 0 1.301.24 1.8.67l.144.136 2.828 2.828c.47.468.751 1.09.799 1.746l.007.198V10a.75.75 0 01-1.493.102L17.25 10V8.75H14a1.75 1.75 0 01-1.744-1.607L12.25 7V3.75H6a1.25 1.25 0 00-1.244 1.122L4.75 5v14c0 .648.491 1.18 1.122 1.244L6 20.25h4a.75.75 0 01.102 1.493L10 21.75H6a2.75 2.75 0 01-2.745-2.582L3.25 19V5a2.75 2.75 0 012.582-2.745L6 2.25h7.172zm3.328 11.5a3.751 3.751 0 00-.2 7.495l.2.005.2-.005.196-.016a3.75 3.75 0 003.349-3.53l.005-.199-.005-.2a3.75 3.75 0 00-3.745-3.55zm1.21 2.32a.75.75 0 011.05 1.048l-.073.084-2.072 2.072-.094.08a.749.749 0 01-.883-.007l-.084-.073-1.242-1.244-.072-.084a.751.751 0 011.05-1.049l.084.073.71.713 1.543-1.541zm-8.38.18a.75.75 0 01.102 1.493l-.102.007H8a.75.75 0 01-.102-1.493L8 16.25h1.33zm1.67-3a.75.75 0 01.102 1.493L11 14.75H8a.75.75 0 01-.102-1.493L8 13.25h3zm3-3a.75.75 0 01.102 1.493L14 11.75H8a.75.75 0 01-.102-1.493L8 10.25h6zm-.249-6.357L13.75 7a.25.25 0 00.193.243L14 7.25h3.108a1.246 1.246 0 00-.13-.2l-.094-.106-2.828-2.828a1.305 1.305 0 00-.196-.16l-.109-.063z"
        />
      </g>
    </svg>
  );
}

export default SvgTasks;
